<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      class="modal-gallery"
      persistent
      max-width="1400px"
      :fullscreen="$vuetify.breakpoint.mdAndDown"
    >
      <v-card>
        <!-- <v-card-title>
          <span class="text-h5">Gallery</span>
        </v-card-title> -->
        <v-card-text
          ref="scrollContainer"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        >
          <v-container
            v-if="deletingFile"
            style="height: 400px;"
          >
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                v-if="!loading"
                class="text-subtitle-1 text-center"
                cols="12"
              >
                {{ result ? 'The file has been deleted.' : 'Are you sure you want to delete this file?' }}
              </v-col>
              <v-col
                v-if="!loading && !result"
                cols="12"
                class="justify-content-center wrapper-buttons-center"
              >
                <v-btn
                  color="primary"
                  @click="submitDelete()"
                >
                  Delete
                </v-btn>
                <v-btn @click="$emit('closingModal', true)">
                  Cancel
                </v-btn>
              </v-col>

              <v-col
                v-if="loading"
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Deleting file...
              </v-col>
              <v-col
                v-if="loading"
                cols="6"
              >
                <v-progress-linear
                  color="primary accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>

          <ContentCategories
            v-if="(galleryList && !resultUpload && !deletingFile) && !$vuetify.breakpoint.mdAndDown"
            :initial-content-type="-1"
            @filterCategory="filterCategory"
          />
          <!-- UPLOAD CONTAINER -->
          <v-row
            v-if="loading && !deletingFile"
            class="fill-height"
            align-content="center"
            justify="center"
            style="height: 400px"
          >
            <v-col
              cols="4"
              class="align-center"
            >
              <v-progress-linear
                color="primary accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>

          <v-container v-if="!galleryList && !resultUpload && !loading">
            <v-card
              color="grey lighten-1"
              height="500px"
            >
              <div class="container">
                <div
                  v-show="!resultUpload"
                  class="row justify-content-center"
                  :class="{ loading: loading }"
                >
                  <div class="col-lg-12">
                    <drag-and-drop @filed="fileLoaded" />
                  </div>
                </div>
              </div>
            </v-card>
          </v-container>

          <!-- UPLOAD CONTAINER -->
          <v-container
            v-if="!deletingFile && galleryList && !loading"
            class="wrapper-multiple-content"
          >
            <v-item-group multiple>
              <v-container>
                <v-row v-if="!filesUser.length && !loading">
                  <v-col
                    class="text-subtitle-1 text-center wrapper-images"
                    cols="12"
                  >
                    There is no content to display.<br />
                    Please select another category.
                  </v-col>
                </v-row>
                <v-row v-if="filesUser.length">
                  <v-col
                    v-for="(file, key) in filesUser"
                    :key="key"
                    cols="6"
                    sm="4"
                    md="3"
                    xl="2"
                    class="wrapper-image"
                  >
                    <label :for="`chk-${key}`">
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center img-container"
                          dark
                          height="200"
                        >
                          <v-icon
                            v-if="existFiles.includes(file.split('.com/')[1].split('?X-Amz')[0])"
                            medium
                            color="darken-2 icon-book"
                          >

                            {{ mdiBookLock }}
                          </v-icon>
                          <span class="wrapper-checkbox"> <!--  v-if="$store.state.diary || $store.state.modal_edit || $store.state.edit_pages || $store.state.modal_upload" -->
                            <span
                              v-if="active"
                              aria-hidden="true"
                              class="v-icon notranslate theme--dark white--text"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                role="img"
                                aria-hidden="true"
                                class="v-icon__svg"
                              >
                                <path d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z"></path>
                              </svg>
                            </span>

                            <span
                              v-if="!active"
                              aria-hidden="true"
                              class="v-icon notranslate theme--dark"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                role="img"
                                aria-hidden="true"
                                class="v-icon__svg"
                              >
                                <path d="M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"></path>
                              </svg>
                            </span>
                            <input
                              :id="`chk-${key}`"
                              v-model="selected"
                              type="checkbox"
                              :value="file"
                              @click="toggle"
                            />
                          </span>

                          <v-icon
                            v-if="!existFiles.includes(file.split('.com/')[1].split('?X-Amz')[0])"
                            dark
                            :class="{'alternate-icon-small': !mdiTrashCan}"
                            class="mx-auto btn-remove"
                            @click="deleteFile(file)"
                          >
                            {{ mdiTrashCan }}
                          </v-icon>
                          <img
                            v-if="isImage(file)"
                            class="preview drag-and-drop-preview"
                            :src="file"
                            loading="lazy"
                            decoding="async"
                            @error="onImgError(file)"
                          />
                          <video
                            v-else-if="isVideo(file)"
                            class="preview drag-and-drop-preview video-preview"
                            controls
                            preload="none"
                          >
                            <source
                              :src="file"
                              :type="getVideoType(file)"
                            >
                            Your browser does not support the video tag.
                          </video>
                        </v-card>
                      </v-item>
                    </label>
                  </v-col>
                </v-row>
                <v-row v-if="loadingMore">
                  <v-col
                    cols="12"
                    class="text-center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="32"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="!loading && !result && (galleryList || !$store.state.diary)"
            color="primary"
            @click="$store.state.gallery.list = !$store.state.gallery.list;resultUpload = false;fileUploaded = []"
          >
            {{ galleryList ? $vuetify.breakpoint.mdAndDown ? 'Upload&nbsp;&nbsp;' : 'Upload new Files&nbsp;&nbsp;' : $store.state.diary ? 'From Gallery&nbsp;&nbsp;' : 'Gallery&nbsp;&nbsp;' }}
            <v-icon
              right
              dark
              :class="{'alternate-icon-small': galleryList ? !mdiCloudUpload : !mdiImageSearch }"
              class="mx-auto"
            >
              {{ galleryList ? mdiCloudUpload : mdiImageSearch }}
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!galleryList && fileUploaded.length && !resultUpload && !loading"
            color="primary"
            @click="submitFiles()"
          >
            Submit Files
          </v-btn>
          <v-btn
            v-if="selected.length && galleryList && !loading"
            color="primary"
            @click="relateFiles()"
          >
            Import
          </v-btn>
          <v-btn
            v-if="!loading && !result"
            @click="$store.commit('showGallery', { open: false, list: false });"
          >
            Close
          </v-btn>
          <v-btn
            v-if="!loading && result"
            @click="back()"
          >
            Back
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { uploadMedia, resourcesChanged, showResourceError } from '@/services/resources'
import axios from 'axios'
import {
  mdiMagnifyScan, mdiTrashCan, mdiBookLock, mdiCloudUpload, mdiImageSearch,
} from '@mdi/js'
import DragAndDrop from '@/components/DragAndDrop.vue'
import ContentCategories from '@/components/ContentCategories.vue'

export default {
  components: {
    DragAndDrop,
    ContentCategories,
  },
  props: ['modals', 'actions'],
  data() {
    return {
      mdiMagnifyScan,
      mdiBookLock,
      mdiTrashCan,
      mdiCloudUpload,
      mdiImageSearch,

      deletingFile: false,
      dialog: true,
      s3: 'https://self-biography-system.s3.us-east-2.amazonaws.com/',
      endpoint: process.env.VUE_APP_ROOT_API,
      loading: false,
      result: false,
      filesUser: [],
      selected: [],
      existFiles: [],
      deleteUrl: null,

      loading: false,
      uploadPercentage: 0,
      resultUpload: false,
      uploader: false,
      fileUploaded: [],
      pagination: 1,
      qtdPages: 1,
      limitItems: 16,
      loadingMore: false,
      hasMore: true,
      categorySelected: '',
      uncategorizedFiles: [],
      failedImages: {},
    }
  },
  computed: {
    galleryList() {
      return this.$store.state.gallery.list
    },
  },
  watch: {
    uploader() {
      this.resetAndLoad()
    },
  },
  created() {
    // Start with all files on both desktop and mobile, regardless of the previous view.
    this.$store.commit('setContentType', -1)
  },
  mounted() {
    this.resetAndLoad()
  },
  beforeDestroy() {
    this.detachScrollListener()
  },
  methods: {
    isImage(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (imageExtensions.includes(ext)) return true
      if (videoExtensions.includes(ext)) return false

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (videoExtensions.includes(ext)) return true

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    getVideoType(filePath) {
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
    filterCategory(value, page) {
      this.categorySelected = value
      this.resetAndLoad()
    },
    fileLoaded(value) {
      this.fileUploaded = value
    },
    relateFiles() {
      this.$store.commit('setGalleryItems', this.selected)
      this.$store.commit('showGallery', { open: false, list: false })
    },
    deleteFile(value) {
      this.deletingFile = true
      this.deleteUrl = value
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`
    },
    resetAndLoad() {
      this.detachScrollListener()
      this.filesUser = []
      this.existFiles = []
      this.uncategorizedFiles = []
      this.pagination = 1
      this.qtdPages = 1
      this.hasMore = true
      this.getUserFiles(false)
    },
    attachScrollListener() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer && this.$refs.scrollContainer.$el
          ? this.$refs.scrollContainer.$el
          : this.$refs.scrollContainer
        if (!el) return
        this.detachScrollListener()
        this._scrollEl = el
        this._onScroll = () => this.handleScroll()
        el.addEventListener('scroll', this._onScroll, { passive: true })
        this.handleScroll()
      })
    },
    detachScrollListener() {
      if (this._scrollEl && this._onScroll) {
        this._scrollEl.removeEventListener('scroll', this._onScroll)
      }
      this._scrollEl = null
      this._onScroll = null
    },
    handleScroll() {
      if (!this.galleryList) return
      if (this.loading || this.loadingMore || !this.hasMore) return
      const el = this._scrollEl
      if (!el) return
      const threshold = 400
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
        this.loadMore()
      }
    },
    loadMore() {
      if (this.loading || this.loadingMore || !this.hasMore) return
      if (this.pagination >= this.qtdPages) {
        this.hasMore = false
        return
      }
      this.pagination += 1
      this.getUserFiles(true)
    },
    getUserFiles(append = false) {
      if (!append) {
        this.filesUser = []
        this.existFiles = []
        this.uncategorizedFiles = []
        this.loading = true
      } else {
        this.loadingMore = true
      }
      axios.get(
        `${this.endpoint}/getS3Files?content_type=${this.$store.state.content_type != null ? this.$store.state.content_type : -1}&category=${this.categorySelected}&limit=${this.pagination},${(this.limitItems)}`, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        },
      ).then(response => {
        const allContent = response.data.content || []
        const totalFromServer = response.data.total_files || allContent.length
        this.qtdPages = Math.max(1, Math.ceil(totalFromServer / this.limitItems))
        response.data.exist.forEach(value => {
          if (!this.existFiles.includes(value.url)) this.existFiles.push(value.url)
        })
        allContent.forEach(value => {
          if (!this.existFiles.includes(value.split('.com/')[1].split('?X-Amz')[0])) {
            this.uncategorizedFiles.push(value)
          }
        })

        const sourceList = this.categorySelected === -2 ? this.uncategorizedFiles : allContent
        // Defensive client-side slicing in case the backend ever returns more
        // than one page in a single response.
        let pageItems = sourceList
        if (sourceList.length > this.limitItems) {
          this.qtdPages = Math.max(this.qtdPages, Math.ceil(sourceList.length / this.limitItems))
          const start = (this.pagination - 1) * this.limitItems
          pageItems = sourceList.slice(start, start + this.limitItems)
        }

        if (append) {
          this.filesUser = this.filesUser.concat(pageItems)
        } else {
          this.filesUser = pageItems
        }

        this.hasMore = this.pagination < this.qtdPages
        this.loading = false
        this.loadingMore = false

        if (!append) {
          this.attachScrollListener()
        } else {
          // Re-check in case the new items still don't fill the viewport.
          this.$nextTick(() => this.handleScroll())
        }
      })
        .catch(() => {
          this.loading = false
          this.loadingMore = false
        })
    },
    submitDelete(url) {
      const self = this
      self.loading = true
      axios.post(`${self.endpoint}/deleteS3File`, {
        filename: decodeURIComponent(self.deleteUrl.split('.com/')[1].split('?')[0]),
      }, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(responseDB => {
        self.loading = false
        self.result = true
      })
    },
    back() {
      this.result = false
      this.deletingFile = false
      this.resultUpload = false
      this.filesUser.splice(this.filesUser.indexOf(this.deleteUrl), 1)
    },
    formatString(str) {
      return str.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
    },
    async submitFiles() {
      this.loading = true
      const keys = []
      try {
        for (const elm of this.fileUploaded) {
          if (typeof elm === 'string') {
            keys.push(elm.includes('amazonaws.com/') ? decodeURIComponent(elm.split('amazonaws.com/')[1].split('?')[0]) : elm)
          } else {
            // Sequential uploads stop at the first limit; successful files are reused on retry.
            // eslint-disable-next-line no-await-in-loop
            const response = await uploadMedia({ buffer: elm.file,
              originalname: this.formatString((elm.name || 'media').toLowerCase().trim().replace(/\s+/g, '-')),
              mime: elm.mimeType }, elm)
            keys.push(response.data.Data.Key)
          }
        }
        this.linkUploadedFiles(keys)
      } catch (_) { this.loading = false }
    },
    linkUploadedFiles(keys) {
      const today = new Date()
      const date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
      // All is a browsing filter; new files still need a concrete content type.
      const contentType = this.$store.state.content_type === 1 ? 1 : 0

      axios.get(`${this.endpoint}/getCategories`, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(catResponse => {
        const firstActive = catResponse.data.content.find(
          c => c.type && c.active && (contentType === 0 ? !c.content_type : !!c.content_type),
        )
        const category = firstActive ? [firstActive.id] : []

        axios.post(`${this.endpoint}/saveFileInfos`, {
          name: '',
          alternative_text: '',
          category,
          tags: [],
          location: '',
          date,
          contentType,
          public: 0,
          view_type: 0,
        }, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        }).then(responseDB => {
          axios.post(`${this.endpoint}/linkFiles`, {
            files: keys,
            date,
            file_id: responseDB.data.fileInfos,
            rotation_position: keys.map(() => 0),
          }, {
            headers: {
              Authorization: this.$store.state.jwtToken,
            },
          }).then(() => {
            this.resultUpload = true
            this.loading = false
            this.uploader = !this.uploader
            this.$store.state.gallery.list = !this.$store.state.gallery.list
          })
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">

.modal-picture-details {
  max-width: 900px !important;
  img {
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .spinner {
    margin: 20px 0 0 -25px;
  }
}
.modal-picture-details .row {
  position: relative;
}

.modal-picture-details .click-region {
  cursor: pointer;
  height: auto;
  position: relative;
  margin-bottom: 20px;

  button {
    display: block;
    background: none;
    position: absolute;
    right: 0px;
    bottom: 5px;
    z-index: 20;
  }
}

.wrapper-text {
  max-height: 50vh;
  overflow: hidden;
  overflow-y: auto;
}

.wrapper-buttons-center {
  text-align: center;
  button {
    margin: 0 10px;
  }
}

.wrapper-multiple-content {
  min-width: 0;
  padding: 0;
}

.wrapper-image {
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 0;
  margin: 0;
  padding: 8px;
  label {
    cursor: pointer;
    width: 100%;
    min-width: 0;
  }

  .img-container {
    width: 100%;
    height: clamp(120px, 22vh, 200px) !important;
    overflow: hidden;
  }

  img,
  video,
  .video-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-width: 0;
    text-align: center;
    overflow-wrap: break-word;
    cursor: pointer;
    display: block;
    max-width: 100%;
    margin: 0;
  }
  .v-icon {
    transform: scale(0.9);
    padding: 5px;
  }
}

.btn-remove,
.wrapper-checkbox,
.text--icon-book {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  padding: 0px;
  background: rgba(0,0,0,0.5);
  border-radius: 100% !important;
}

.text--icon-book {
  top: 10px;
}

.wrapper-checkbox {
  top: 50%;
  left: 10px;
  right: auto;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  margin: 0;

  .v-icon {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.wrapper-checkbox {
  input[type="checkbox"] {
    display: none;
  }
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 8px;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
}

.v-pagination-scroll-left,
.v-pagination-scroll-right {
  position: absolute;
  left: 24%;
}

.v-pagination-scroll-right {
  left: auto;
  right: 20%;
  transform: rotate(180deg);
}

.pagination-list {
  li {
    list-style: none;
    float: left;
    margin: 0 10px;
  }
}
</style>
